// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-container[data-v-55c78b9e]{background-color:var(--body-bg)}.error-container .title[data-v-55c78b9e]{font-size:20px;font-weight:700}@media(max-width:991.98px){.error-container .title[data-v-55c78b9e]{text-transform:uppercase}}.error-container .btn-info[data-v-55c78b9e]{font-size:16px;font-weight:700;line-height:1em;padding:18px;text-transform:uppercase}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
